import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Champ de recherche d'une page de liste, prérempli par « ?q=… » dans l'adresse (résultat choisi dans la
 * recherche de l'en-tête). Une nouvelle recherche vers la même page met le champ à jour.
 */
export function useUrlSearch(): [string, (value: string) => void] {
  const [params] = useSearchParams();
  const fromUrl = params.get("q") ?? "";
  const [search, setSearch] = useState(fromUrl);
  useEffect(() => {
    if (fromUrl) setSearch(fromUrl);
  }, [fromUrl]);
  return [search, setSearch];
}
